
import {
    ReactElement,
    HTMLAttributes
} from "react";
interface Props extends HTMLAttributes<HTMLElement> {
    placeholder: string;
    value: string;
    myStyle?: string;
    onChange?: any;
    lable?: string;
    contentLoading?: boolean;
    error?: string;
}

export function Textarea({ placeholder, value, myStyle, onChange, lable , contentLoading , error }: Props): ReactElement {

    return (
        <div className={`${myStyle && myStyle} custom-textarea`} >
            {lable &&
            <>
             {contentLoading ?
                        <div className="input-loading-lable content-loading">
                        </div>
                        :
                <label className="custom-textarea-lable">
                    {lable}
                </label>
            }
            </>
            }
            {contentLoading ? <div className="content-loading w-100">
            </div> :
            <textarea
                className="textarea"
                placeholder={placeholder}
                defaultValue={value}
                onChange={onChange}
            />
        }
        {error &&
            <label className="custom-textarea-error">
                {error}
            </label>
        }
        </div>
    );
}

export default Textarea;